<template>
  <div v-if="estado.mostrar" class="modal-overlay-alerta" @click.self="cerrar">
    <div class="modal-alerta">
      <div class="modal-alerta-header" :class="estado.tipo">
        <span class="modal-icono">{{ icono }}</span>
        <h3>{{ titulo }}</h3>
      </div>
      <div class="modal-alerta-body">
        <p>{{ estado.mensaje }}</p>
      </div>
      <div class="modal-alerta-footer">
        <button
          v-if="estado.tipo === 'confirm'"
          class="btn-modal btn-cancelar"
          @click="cerrar"
        >
          Cancelar
        </button>
        <button
          class="btn-modal btn-aceptar"
          :class="{ peligro: estado.peligro }"
          @click="onAceptar"
        >
          {{ textoBoton }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useDialog } from "@/composables/useDialog";
import { useScrollLock } from "@/composables/useScrollLock";

const { estado, cerrar, _ejecutarConfirm } = useDialog();

// Bloquear el scroll del fondo mientras el diálogo está abierto (contador compartido).
useScrollLock(() => estado.mostrar);

const icono = computed(() => {
  if (estado.tipo === "confirm") return "❓";
  if (estado.tipo === "success") return "✅";
  return "⚠️";
});

const titulo = computed(() => {
  if (estado.tipo === "confirm") return "Confirmación";
  if (estado.tipo === "success") return "Éxito";
  return "Aviso";
});

const textoBoton = computed(() => {
  if (estado.textoBoton) return estado.textoBoton;
  return estado.tipo === "confirm" ? "Sí, continuar" : "Entendido";
});

function onAceptar() {
  if (estado.tipo === "confirm") _ejecutarConfirm();
  else cerrar();
}
</script>

<style scoped>
.modal-overlay-alerta {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 3000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-alerta {
  background: white;
  width: 90%;
  max-width: 400px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  animation: slideIn 0.2s ease-out;
}

@keyframes slideIn {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.modal-alerta-header {
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  color: white;
}

/* Aviso (rojo/naranja), confirmación (azul) y éxito (verde). */
.modal-alerta-header.error {
  background: linear-gradient(135deg, #f39c12 0%, #e67e22 100%);
}
.modal-alerta-header.confirm {
  background: linear-gradient(135deg, #678AB2 0%, #4d6f96 100%);
}
.modal-alerta-header.success {
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
}

.modal-icono {
  font-size: 24px;
}

.modal-alerta-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.modal-alerta-body {
  padding: 24px;
  color: #333;
  line-height: 1.6;
}

.modal-alerta-body p {
  margin: 0;
  font-size: 15px;
}

.modal-alerta-footer {
  padding: 16px 24px;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  background: #f8f9fa;
  border-top: 1px solid #e5e7eb;
}

.btn-modal {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

/* Botón aceptar: azul por defecto; rojo cuando la acción es destructiva (peligro). */
.btn-aceptar {
  background: #678AB2;
  color: white;
}
.btn-aceptar:hover {
  background: #4d6f96;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(103, 138, 178, 0.3);
}
.btn-aceptar.peligro {
  background: #dc2626;
}
.btn-aceptar.peligro:hover {
  background: #b91c1c;
  box-shadow: 0 4px 8px rgba(220, 38, 38, 0.3);
}

.btn-cancelar {
  background: #e5e7eb;
  color: #333;
}
.btn-cancelar:hover {
  background: #d1d5db;
}
</style>
